import createHistory from 'history/createBrowserHistory'

import { getAppPath } from './appHostPath'

export default createHistory({ basename: getAppPath() })
